import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChevronLeft = () => {
  return (
    <g>
      <path d="M11.77 13.708a.75.75 0 0 1-.955 1.151l-.085-.07-6.499-6.25a.75.75 0 0 1-.076-.995l.076-.085L10.73 1.21a.751.751 0 0 1 1.115.999l-.074.082L5.835 8l5.936 5.709z" />
    </g>
  );
};

export default withIcon(IconChevronLeft);
